import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flex: 1,
  },
  sectionTitle: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    color: "#344054",
    margin: 0,
  },
  reportsList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "400px",
    overflowY: "auto",
    paddingRight: "8px",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#F9FAFB",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#D0D5DD",
      borderRadius: "4px",
      "&:hover": {
        backgroundColor: "#98A2B3",
      },
    },
  },
  reportItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  reportLabel: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: "#344054",
    margin: 0,
  },
  actionsRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "8px",
    borderTop: "1px solid #E4E7EC",
  },
  actionLink: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    color: "#0055A4",
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
    "&:disabled": {
      color: "#98A2B3",
      cursor: "not-allowed",
      textDecoration: "none",
    },
  },
}));

export default useStyles;

